import { CropRect } from "../../utils/videoTrim";

export type UploadSourceKind = "trimmed" | "original_fallback";

export type TeacherWebUploadDraft = {
  bucket: string;
  cdnDomain: string | null;
  cropRect: CropRect;
  durationSec: number;
  exportError: string | null;
  fileSize: number;
  idempotencyKey: string;
  linkId: number;
  mimeType: string;
  objectKey: string;
  originalFileName: string;
  originalFileSize: number;
  originalMimeType: string;
  originalVideoDurationSec: number;
  originalVideoHeight: number;
  originalVideoWidth: number;
  outputFrameCount: number;
  outputFramesPerSecond: number;
  outputVideoHeight: number;
  outputVideoWidth: number;
  region: string;
  sourceKind: UploadSourceKind;
  startTimeSec: number;
  studentUserId: number;
  teacherToken: string;
  teacherUserId: number;
  uploadedAt: string;
};

export function createUploadIdempotencyKey(): string {
  if (typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0"));
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10).join(""),
  ].join("-");
}

function draftStorageKey(token: string, userId: number): string {
  return `pingpi.teacherWeb.uploadDraft.v1.${token}.${userId}`;
}

export function clearUploadDraft(token: string, userId: number): void {
  try {
    window.localStorage.removeItem(draftStorageKey(token, userId));
  } catch {
    // Some embedded browsers restrict storage. Clearing in-memory state is still enough.
  }
}
